import React from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import useTheme from "../../hooks/useTheme";
import { PlatformType } from "../../types/types";
import useStyles from "../../hooks/useStyles";

export default function Windows(props: { style?: React.CSSProperties }) {
  const { isSmallLayout } = useWindowDimensions();
  const theme = useTheme();

  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <img
        src={theme.images.windows}
        style={isSmallLayout ? useStyles.iconSmall : useStyles.iconLarge}
        alt={PlatformType.windows}
      />
    </div>
  );
}
